/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Consent_HealthInputs */

const en_signup_consent_health = /** @type {(inputs: Signup_Consent_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I explicitly consent to Complete Athlete processing the health-related data I enter, such as injuries, weight and meals, to provide its training and nutrition features. I can withdraw this at any time.`)
};

const pl_signup_consent_health = /** @type {(inputs: Signup_Consent_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyrażam wyraźną zgodę na przetwarzanie przez Complete Athlete wprowadzanych przeze mnie danych dotyczących zdrowia, takich jak kontuzje, waga i posiłki, w celu zapewnienia funkcji treningowych i żywieniowych. Mogę wycofać tę zgodę w każdej chwili.`)
};

/**
* | output |
* | --- |
* | "I explicitly consent to Complete Athlete processing the health-related data I enter, such as injuries, weight and meals, to provide its training and nutritio..." |
*
* @param {Signup_Consent_HealthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const signup_consent_health = /** @type {((inputs?: Signup_Consent_HealthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Consent_HealthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_signup_consent_health(inputs)
	return en_signup_consent_health(inputs)
});